var React = require('react');

function AddMain (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group"),React.createElement("g",{"id":"//-Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("g",{"id":"icons/blurb/Add","transform":"translate(-9.4167, -9.4167)","stroke":"#5B00DB","strokeWidth":"2"},React.createElement("g",{"id":"Group","transform":"translate(10, 10)"},[React.createElement("line",{"x1":"10","y1":"0.416666667","x2":"10","y2":"19.5833333","id":"Line-4","key":0}),React.createElement("line",{"x1":"10","y1":"0.416666667","x2":"10","y2":"19.5833333","id":"Line-4","transform":"translate(10, 10) rotate(-90) translate(-10, -10)","key":1})])))]);
}

AddMain.defaultProps = {"width":"21.1666667px","height":"21.1666667px","viewBox":"0 0 21.1666667 21.1666667","version":"1.1"};

module.exports = AddMain;

AddMain.default = AddMain;
